import PromineoQuickStartSetps from "./PromineoStartSetps";
import Link from "../../../../components/common/LinkButton";

export default function QuickStartSteps() {
  const step1Header = "Step 1: Your input data";
  const step1Section1 = "timePhasing doesn’t create numbers out of nowhere, it need your input data to get started.";
  const step1Section2 = "Input data can be various things. If you are a planner the input data may be a project schedule, if you are a controller it may be budget items with start and finish dates.";

  const step2Header = "Step 2: Label your input data";
  const step2Section1 = "In order to understand what’s what, the timePhasing service needs you to provide information about your data to make calculations.";
  const step2Section2 = "For example, which fields in your data set contains the value you want to time-phase? This can be a field that contains cost, man-hours or any other quantity you desire to display in Output Data.";

  const step3Header = "Step 3: Specify output requirements";
  const step3Section1 = "How do you want timePhasing to process the data? What output are you looking for? And in what format?";
  const step3Section2 = "For example, do you want the Output Data to be time-phased by week, month or perhaps year?";

  const step4Header = "Step 4: The output data";
  const step4Section1 = "Based on Element 1, 2 and 3 the timePhase service will return a periodic data set that can be visualised as histograms and/or as a table.";
  const step4Section2 = "For example the Output Data can be a table with projects and their monthly cost budget.";

  const handleClick = () => {
    let jsonDocumentationPage = `https://www.opc-router.com/what-is-json/#JSON-Document`; 
    window.open(jsonDocumentationPage);
  }

  return (
    <div>
      <div className="ml-45 mt-20 text-promBlack1 font-inter font-bold text-16 leading-19 border-b-4 inline-block">
        Quick start steps
      </div>

      <div className="mt-9 ml-45 text-promBlack1 text-base font-inter">
        timePhasing is a data processing API. It operates according to the following steps.
      </div>

      <div className="relative">
        <div className="h-full absolute left-191px border-l-1.5 border-solid border-promGrey5 z-1"></div>
        <div className="mt-16">
          <PromineoQuickStartSetps
            header={step1Header}
            section1={step1Section1}
            section2={step1Section2}
          />
        </div>

        <div className="mt-8">
          <PromineoQuickStartSetps
            header={step2Header}
            section1={step2Section1}
            section2={step2Section2}
          />
        </div>

        <div className="mt-8">
          <PromineoQuickStartSetps
            header={step3Header}
            section1={step3Section1}
            section2={step3Section2}
          />
        </div>

        <div className="mt-8">
          <PromineoQuickStartSetps
            header={step4Header}
            section1={step4Section1}
            section2={step4Section2}
          />
        </div>
        <hr className="border-promGrey5 relative w-7px top-1px left-188px"/>
      </div>

      <div className="ml-57 mt-16 mb-20 bg-promWhite1 shadow-custom rounded w-591px h-30 relative">
        <div className="mt-4 ml-4 text-promBlack1 font-inter text-14px leading-22px font-bold absolute">A note on the data format</div>
        <div className="mt-38px ml-4 mb-4 mr-4 font-inter text-14px leading-22px absolute">
          Data in timePhasing is always formatted in JSON. This is the case for both input and output data. A basic understanding of JSON will be very useful when reading this guide. If you’re not familiar with the format, we suggest you read up on it{" "}
          <Link className="text-primaryRed" onClick={handleClick}>
            here
          </Link>
          .
        </div>
      </div>
    </div>
    
  );
}
